import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDiscPoint, renderDynamicTable, renderIndentation, renderReportfield} from '../../utils/templateUtils';
import './positivePrescriptionAdvanced.scss';

export default function PositivePrescriptionAdvanced(props) {
  const [showTables, setShowTables] = useState({
    medication: true
  });
  const [formData, setFormData] = useState({
    etDate: '',
    betaHcgResult: '',
    ultrasoundScanDate: '',
    comorbidities: '',
    comorbiditiesOthers: '',
    advice: ''
  });
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const [medicationRows, setMedicationRows] = useState([
    {sno: '1', drug: 'T. Progynova', genericName: 'Estradiol valerate', dosage: '2 mg', freq: '1-1-1 (8 AM / 3 PM / 8 PM)', route: 'Oral', duration: '30 Days'},
    {sno: '2', drug: 'C. Folvista', genericName: 'L-methylfolate + Myoinositol', dosage: '-', freq: '0-0-1', route: 'Oral', duration: '30 days'},
    {sno: '3', drug: 'Tab. Ecosprin 75/150', genericName: 'Aspirin', dosage: '-', freq: '0-0-1 (in the night after meal)', route: 'Oral', duration: '30 days'},
    {sno: '4', drug: 'Inj. Strone Aq', genericName: 'Aqueous Progesterone', dosage: '50 mg', freq: 'daily', route: 'IM', duration: '30 days'},
    {sno: '5', drug: 'T. Dydrofirst', genericName: 'Dydrogesterone', dosage: '10 mg', freq: '1-1-1 (8 AM / 3 PM / 8 PM)', route: 'Oral', duration: '30 days'},
    {sno: '6', drug: 'C. Gestobond', genericName: 'Micronized Progesterone', dosage: '400 mg', freq: '1-0-1 (10 AM & 10 PM)', route: 'Vaginal', duration: '30 days'},
    {sno: '7', drug: 'Susten Gel', genericName: 'Progesterone Gel', dosage: '90 mg', freq: '1-0-1', route: 'Vaginal', duration: '30 days'},
    {sno: '8', drug: 'T. HCQ', genericName: 'Hydroxychloroquine', dosage: '200 mg', freq: '1-0-1', route: 'oral', duration: '30 days'},
    {sno: '9', drug: 'T. Wysolone', genericName: 'Prednisolone', dosage: '10 mg', freq: '1-0-1', route: 'oral', duration: '30 days'},
    {sno: '10', drug: 'Syp. Looz', genericName: 'Lactulose', dosage: '10 ml', freq: '0-0-1', route: 'oral', duration: '15 days'},
    {sno: '11', drug: 'Intiwash', genericName: 'Vaginal Wash', dosage: '-', freq: 'SOS', route: '-', duration: 'As needed'},
    {sno: '12', drug: 'Inj. Hucog', genericName: 'hCG', dosage: '5000 IU', freq: '-', route: '-', duration: 'As advised'},
    {sno: '13', drug: 'Inj. Evaparin', genericName: 'Enoxaparin', dosage: '40 mg', freq: 'daily', route: 'SC', duration: '30 days'},
    {sno: '14', drug: 'T. Thyronorm', genericName: 'Levothyroxine', dosage: '-', freq: '1-0-0 (Empty stomach)', route: 'oral', duration: '30 days'},
    {sno: '15', drug: 'T. Trapic', genericName: 'Tranexamic Acid', dosage: '-', freq: '1-1-1', route: 'oral', duration: '2 days (1 strip)'},
    {sno: '16', drug: 'T. Vomibune / Vomikind', genericName: 'Antiemetic', dosage: '-', freq: '1-0-1', route: 'oral', duration: '1 strip if vomiting'},
    {sno: '17', drug: 'Syp. Evaraft', genericName: 'Antacid', dosage: '10 ml-0-10 ml', freq: 'SOS / Heartburn', route: 'oral', duration: '1 bottle'},
    {sno: '18', drug: 'T. C Vit / Celin', genericName: 'Vitamin C', dosage: '500 mg', freq: '1-0-1', route: 'Oral', duration: '30 days'},
    {sno: '19', drug: 'T. Neuroplex / Neurobion', genericName: 'Vitamin B-complex', dosage: '1 tab', freq: 'OD', route: 'Oral', duration: '30 days'}
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug Name'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency/Timing'},
    {key: 'route', label: 'Route'},
    {key: 'duration', label: 'Duration'}
  ];

  const handleChange = e => {
    if (e && e.target) {
      const {name, value} = e.target;
      setFormData({...formData, [name]: value});
    } else {
      // Handling for SelectField component that might pass value directly
      setFormData({...formData, comorbidities: e});
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('positivePrescriptionAdvancedReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Positive Prescription Advanced'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const renderComorbidities = () => {
    if (formData.comorbidities === 'Others') {
      return formData.comorbiditiesOthers || 'Others';
    }
    return formData.comorbidities;
  };

  return (
    <div id='PositivePrescriptionAdvancedTemplate'>
      <div className='PositivePrescriptionAdvancedTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>POSITIVE PRESCRIPTION ADVANCED – ET FOLLOW-UP MEDICATION</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail pb-2'>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='ET Date:' name='etDate' value={formData.etDate} required={false} onChange={handleChange} inputClassName='show' type='date' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Beta-hCG:' name='betaHcgResult' value={formData.betaHcgResult} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Ultrasound Scan :'
                name='ultrasoundScanDate'
                value={formData.ultrasoundScanDate}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                type='date'
              />
            </div>
          </div>
          <div className='row mb-2'>
            <div className='col-md-4'>
              <SelectField
                label='Comorbidities'
                name='comorbidities'
                value={formData.comorbidities}
                options={[
                  {label: 'DM', value: 'DM'},
                  {label: 'HT', value: 'HT'},
                  {label: 'Thyroid', value: 'Thyroid'},
                  {label: 'Others', value: 'Others'}
                ]}
                onChange={e => handleChange(e, 'comorbidities')}
                placeholder='Please select'
              />
            </div>
            {formData.comorbidities === 'Others' && (
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Others:' name='comorbiditiesOthers' value={formData.comorbiditiesOthers} required={false} onChange={handleChange} inputClassName='show' />
              </div>
            )}
          </div>
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='POST-ET MEDICATION SCHEDULE'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        <div className='bulletin'>
          <h4 style={{fontWeight: 'bold'}}>POST–EMBRYO TRANSFER (ET) INSTRUCTIONS</h4>
          <ul>
            <li>Continue all medications as prescribed by your fertility consultant</li>
            <li>If bleeding occurs:</li>
            <ul style={{listStyleType: 'circle', marginLeft: '20px'}}>
              <li>Stop Enoxaparin and Ecospirin for 5 days</li>
              <li>Start Trapic (Tranexamic acid) 1-1-1</li>
              <li>Inform your doctor immediately</li>
            </ul>
          </ul>
        </div>

        <div className='d-flex align-items-start py-2'>
          <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>
            ADVICE:
          </label>
          <textarea className='Textarea' placeholder='ADVICE' id='advice' name='advice' onChange={handleChange} rows='4' cols='100'></textarea>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='positivePrescriptionAdvancedReport'>
        <div id='positivePrescriptionAdvancedReportWrap'>
          <Headers />
          <p className='Dani'></p>
          <div className='patient' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '5px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>POSITIVE PRESCRIPTION ADVANCED – ET FOLLOW-UP MEDICATION</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('ET Date:', formData.etDate?.split('-').reverse().join('-'))}
            {renderReportfield('Beta-hCG:', formData.betaHcgResult)}
            {renderReportfield('Ultrasound Scan :', formData.ultrasoundScanDate?.split('-').reverse().join('-'))}
            {renderReportfield('Comorbidities:', renderComorbidities())}
          </div>
          {/* Display the selected comorbidities in the report */}

          {showTables.medication &&
            renderDynamicTable(
              'POST-ET MEDICATION SCHEDULE',
              ['S.No', 'Drug Name', 'Generic Name', 'Dose', 'Frequency/Timing', 'Route', 'Duration'],
              ['sno', 'drug', 'genericName', 'dosage', 'freq', 'route', 'duration'],
              medicationRows
            )}

          <div style={{marginTop: '10px'}}>
            <h6 style={{fontWeight: 'bold'}}>POST–EMBRYO TRANSFER (ET) INSTRUCTIONS</h6>
            <div style={{display: 'flex', marginBottom: '5px'}}>
              {renderIndentation()}
              {renderDiscPoint()}
              <span>Continue all medications as prescribed by your fertility consultant</span>
            </div>
            <div style={{display: 'flex', marginBottom: '5px'}}>
              {renderIndentation()}
              {renderDiscPoint()}
              <span>If bleeding occurs:</span>
            </div>
            <div style={{display: 'flex', marginBottom: '5px', marginLeft: '30px'}}>
              {renderIndentation()}
              <span>● Stop Enoxaparin and Ecospirin for 5 days</span>
            </div>
            <div style={{display: 'flex', marginBottom: '5px', marginLeft: '30px'}}>
              {renderIndentation()}
              <span>● Start Trapic (Tranexamic acid) 1-1-1</span>
            </div>
            <div style={{display: 'flex', marginBottom: '5px', marginLeft: '30px'}}>
              {renderIndentation()}
              <span>● Inform your doctor immediately</span>
            </div>
          </div>

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice}</pre>
          </div>
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
